import { useNavigate } from 'react-router-dom';
import { useTenant } from 'context/TenantContext';
import { useClock, SOC_SCREENS } from './useCommandData';
import './commandement.css';

const VIEWS = [
  { path: '/commandement/carte', icon: '\uD83D\uDDFA\uFE0F', label: 'CARTE OPERATIONNELLE', desc: 'Vue temps reel de tous les sites sur la carte' },
  { path: '/commandement/incidents', icon: '\u26A0\uFE0F', label: 'INCIDENTS & ALERTES', desc: 'Gestion des incidents actifs et alertes systeme' },
  { path: '/commandement/agents', icon: '\uD83D\uDC65', label: 'AGENTS & RONDES', desc: 'Statut des agents par site et rondes en cours' },
];

export default function CommandementHub() {
  const navigate = useNavigate();
  const tenant = useTenant();
  const { timeStr, dateStr } = useClock();

  const openAllViews = () => {
    VIEWS.forEach(v => window.open(v.path, '_blank'));
  };

  return (
    <div className="cmd-root">
      <header className="cmd-header">
        <div className="cmd-header-left">
          <div className="cmd-logo">G</div>
          <span className="cmd-header-title">{tenant?.nom || 'GSS-360'} — SALLE DE COMMANDEMENT</span>
        </div>
        <div className="cmd-header-right">
          <span className="cmd-date">{dateStr}</span>
          <span className="cmd-clock">{timeStr}</span>
          <button className="cmd-back-btn" onClick={() => navigate('/')}>RETOUR</button>
        </div>
      </header>

      <div className="cmd-hub">
        {VIEWS.map(v => (
          <div key={v.path} className="cmd-hub-card" onClick={() => navigate(v.path)}>
            <span className="cmd-hub-icon">{v.icon}</span>
            <span className="cmd-hub-label">{v.label}</span>
            <span className="cmd-hub-desc">{v.desc}</span>
          </div>
        ))}
      </div>

      <div style={{ textAlign: 'center', marginBottom: 20 }}>
        <button className="cmd-hub-multi-btn" onClick={openAllViews}>
          MODE 3 ECRANS
        </button>
      </div>

      <div className="cmd-status-bar">
        {SOC_SCREENS.map(s => (
          <div key={s.label} className="cmd-status-item">
            <span className="cmd-status-led" />
            <span className="cmd-status-label">{s.label} {s.status}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
